export const TEMPLATE_SECTION_BODY_PLACEHOLDER = `Example:
Temperature: [patient's temperature] F
Weight: [patient's weight] lbs
Eyes: [findings on patient's eyes OR "Unremarkable" if not mentioned]
Ears: [patient's ear status OR "Not mentioned"]`.trim();

export const TEMPLATE_SECTION_FIELD_PLACEHOLDER = `[patient's weight] lbs`;
